import { FC } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { ImageField, LinkField } from '@prismicio/client'
import tw from 'twin.macro'
import { Body, Grid } from '../UI'
import { PrismicLinkOrDiv } from '../PrismicLinkInternalOrExternal'

type Props = {
  header: string
  press: Array<{
    name: string
    logo: ImageField
    link?: LinkField
  }>
}

const PressLogos: FC<Props> = ({ header, press }) => {
  return (
    <section
      id="press"
      tw="bg-gb-cream pt-[50px] pb-[60px] text-gb-blue font-domaine"
    >
      <Grid>
        <div tw="col-span-full text-center">
          <h2 css={[Body, tw`mb-[29px] lg:mb-[36px]`]}>{header}</h2>
        </div>
        <div tw="col-span-full">
          <div tw="w-full flex flex-wrap justify-center">
            {press &&
              press.map((pressItem, index) => (
                <PrismicLinkOrDiv
                  key={`press-${index}`}
                  field={pressItem.link}
                  cssStyle={tw`flex justify-center items-center`}
                >
                  <GatsbyImage
                    key={`press-${index}`}
                    image={getImage(pressItem.logo)}
                    tw="max-h-5 max-w-[100px] mx-1 my-3 lg:(max-h-9 max-w-[150px] mx-10)"
                    imgStyle={{ objectFit: 'contain' }}
                    alt={pressItem.name}
                  />
                </PrismicLinkOrDiv>
              ))}
          </div>
        </div>
      </Grid>
    </section>
  )
}

export default PressLogos
